module.exports = {"540227100":"卡嘎镇","540227200":"达木夏乡","540227201":"查布乡","540227202":"春哲乡","540227203":"则许乡","540227204":"娘热乡","540227205":"措布西乡","540227206":"纳当乡","540227207":"青都乡","540227208":"切琼乡","540227209":"美巴切勤乡","540227210":"列巴乡","540227211":"塔丁乡","540227212":"荣玛乡","540227213":"通门乡","540227214":"达那普乡","540227215":"达那答乡","540227216":"南木切乡","540227217":"仁钦则乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540227.json
// module id = 2694
// module chunks = 0